<section class="py-3">
  <div class="container-fluid card">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <app-main-heading [heading]="'Services'" class="m-0"></app-main-heading>
      <div>
        @if(isAdmin) {
          <button class="btn app-btn-primary" style="height: 38px; display: flex; align-items: center; justify-content: center;" (click)="serviceFormPopup('Add')">Add Service</button>
        }
      </div>
    </div>
    <div class="card app-table-thick-border shadow-none">
      <div class="table-responsive">
        <table class="table app-table-rounded align-middle m-0 w-100">
          <thead>
            <tr class="app-table-header">
              <th>Name</th>
              <th>Status</th>
              <th>Amount</th>
              @if(isAdmin) {
                <th scope="col">Action</th>
              }
            </tr>
          </thead>
          <tbody>
            @if (metaDataList.length > 0) {
              @for (list of metaDataList; track list) {
                <tr class="app-table-body app-td-text">
                  <td class="td-text-three fw-bold">{{list.label}}</td>
                  <td [ngClass]="list.status == 'Active' ? 'td-text-green':'td-text-red'">{{list.status}}</td>
                  <td class="td-text-two">{{list.amount || 0}}</td>
                  @if(isAdmin) {
                    <td>
                      <fa-icon class="btn app-btn-primary btn-sm" (click)="serviceFormPopup('update',list)" [icon]="faEdit"
                        size="lg" ngbTooltip="Edit" [placement]="'right'"></fa-icon> &nbsp;
                    </td>
                  }
                </tr>
              }
            }  
            @if (loader) {
              <tr>
                <td [colSpan]="isAdmin ? 4 : 3">
                  <div class="custom-col-width-100 d-flex justify-content-center py-5">
                    <app-loader [loadingIcon]="loader"></app-loader>
                  </div>
                </td>
              </tr>
            }
            @if (!loader && metaDataList.length === 0) {
              <tr>
                <td [colSpan]="isAdmin ? 4 : 3">
                  <div class="custom-col-width-100 text-danger d-flex justify-content-center py-5 fw-semibold">
                    No Records Found!
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>



  @if (showEditMakePopup) {
  <div class="popup-overlay">
    <div class="popup-container">
      <h3>{{popupType}} Service</h3>
      <form [formGroup]="serviceForm" (ngSubmit)="onEditSubmit()">
        <div class="row pt-2 g-1">
          <div class="col-12 mb-2">
            <label for="name" class="form-label">Name<span class="text-danger">*</span></label>
            <input formControlName="label" id="name" type="text" class="form-control default-form-group-border" required
              placeholder="Enter Label*">
            @if (
            serviceForm.get('label')?.invalid &&
            serviceForm.get('label')?.touched
            ) {
            <div>
              <small class="text-danger">Label is required</small>
            </div>
            }
          </div>
          <div class="col-12 mb-2">
            <label for="amountInput" class="form-label">Amount</label>
            <input id="amountInput" formControlName="amount" type="number" class="form-control default-form-group-border"
              placeholder="Enter Amount" min="1" />
            @if (serviceForm.get('amount')?.invalid && serviceForm.get('amount')?.touched) {
            <small class="text-danger">Amount must be greater than 0</small>
            }
          </div>
          <div class="col-12 mb-2">
            <span class="form-label d-block">Status</span>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                formControlName="status" [attr.aria-checked]="serviceForm.get('status')?.value ?? false">
              <label class="form-check-label" for="flexSwitchCheckDefault">
                {{serviceForm.get('status')?.value ? 'Active' : 'Deactive'}}
              </label>
            </div>
          </div>
          @if (errorMessage) {
            <div class="text-danger mb-2">{{errorMessage}}</div>
          }
        </div>
        <!-- Action Buttons -->
        <div class="row pt-3">
          <div class="col-12 d-flex justify-content-end gap-2 button_section">
            <button type="button" class="btn pr-2" (click)="closePopup()">Cancel</button>
            <button type="submit" class="btn app-btn-primary sub_button" [disabled]="serviceForm.invalid">
              {{this.popupType}}
              @if (isLoading) {
                <output class="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output>
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  }
</section>

@if (isToster) {
<app-toaster [title]="message" (closeToaster)="closeToster($event)"></app-toaster>
}